var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRari(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "400.000000pt",
    height: "400.000000pt",
    viewBox: "0 0 400.000000 400.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,400.000000) scale(0.100000,-0.100000)",
    fill: "#fff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1040 2000 l0 -720 285 0 285 0 0 245 0 246 378 -3 c350 -3 379 -4 408 -22 57 -34 64 -65 64 -276 l0 -190 283 0 c156 0 286 2 288 4 2 2 2 112 -1 243 l-5 238 -32 61 c-36 70 -96 128 -161 156 l-46 21 50 24 c109 55 164 140 172 267 15 252 -120 383 -429 416 -53 5 -411 10 -816 10 l-723 0 0 -720z m1413 292 c32 -30 41 -65 27 -106 -21 -66 -23 -66 -469 -66 l-401 0 0 100 0 101 409 -3 409 -3 25 -23z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRari);
export default __webpack_public_path__ + "static/media/Rari.8c40b912a7c86844b6349d27f286f559.svg";
export { ForwardRef as ReactComponent };